import React, { useState } from 'react';
import { Columns, Column, Card } from '@codeparva/ui-components-library';
import { JumbotronTypes } from '../../jumbotronTypes';
import { TextOverlay } from './cardHelper/TextOverlay';
// import { Price } from './cardHelper/Price';
import { CTA } from './cardHelper/CTA';
import { CardFormattedHrs } from './cardHelper/CardFormattedHrs';
import { useWindowDimensions } from '../../../../../../utilities/Dimensions';
import { jumbotronxsscreensize } from '../../../../../../utilities/constants';

export const CardDetailsLocation = ({
  textOverlay,
  contactDetails,
  variant,
}: JumbotronTypes.ICard) => {
  const { width } = useWindowDimensions();
  const [isActive, setIsActive] = useState(false);
  const handeClick = () => {
    setIsActive(!isActive);
  };
  return (
    <div className="CardSectionContainer">
      <Columns className="CardSingleLocation" marginless>
        <Column narrow={true} className="p-0 m-1">
          <Card shadowless className="Card p-0">
            <Card.Content className="pl-0 pb-3 pt-0">
              <Columns>
                <Column narrow={true} className="is-flex-shrink-1">
                  <TextOverlay textOverlay={textOverlay} variant={variant} />
                </Column>
              </Columns>
            </Card.Content>
            <Card.Content className="py-3 pl-0">
              <Columns className="is-mobile is-align-items-center is-justify-content-space-between">
                <Column narrow={true} paddingless>
                  <Card
                    shadowless
                    className={`${
                      width <= jumbotronxsscreensize ? 'p-0' : 'p-2'
                    }`}
                    onClick={handeClick}
                  >
                    <Card.Content className="p-2">
                      {contactDetails &&
                        contactDetails[0].facilityHours.gateHrs &&
                        contactDetails[0].facilityHours.officeHrs && (
                          <CardFormattedHrs />
                        )}
                    </Card.Content>
                  </Card>
                </Column>
                {/* <Column narrow={true} className="p-3">
                  <Card
                    shadowless
                    className={
                      width <= jumbotronxsscreensize
                        ? 'p-0'
                        : 'pb-2 pt-2 pr-2 pl-0'
                    }
                  >
                    <Card.Content paddingless>
                      <Price
                        variant={variant}
                        priceSection={
                          contactDetails!.slice(0, 1).shift()!.priceSection
                        }
                      />
                    </Card.Content>
                  </Card>
                </Column> */}
              </Columns>
            </Card.Content>
            <Card.Content className="p-0">
              <CTA
                buttonText={contactDetails?.slice(0, 1).shift()?.buttonText}
                variant={variant}
              />
            </Card.Content>
          </Card>
        </Column>
      </Columns>
    </div>
  );
};
